export const caretDownIcon = `
<svg width="24" height="24" viewBox="-9 -9 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.520734 0.808H6.48473L3.50273 6.772L0.520734 0.808Z" fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
